import React, { useState } from 'react';
import Navigation from './Navigation';

const AppLayout = ({ 
  children, 
  activeTab, 
  onTabChange, 
  user, 
  onLogout,
  theme = 'light',
  onToggleTheme = () => {}
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    try { return localStorage.getItem('sidebar_collapsed') === 'true'; } catch { return false; }
  });
  const isDark = theme === 'dark';

  const handleToggleCollapse = () => {
    setIsSidebarCollapsed(prev => {
      const next = !prev;
      try { localStorage.setItem('sidebar_collapsed', String(next)); } catch {}
      return next;
    });
  };

  return (
    <div className={`h-screen w-screen flex overflow-hidden relative ${
      isDark ? 'bg-[#1f1f1f]' : 'bg-gray-50'
    }`}>
      <Navigation 
        activeTab={activeTab}
        onTabChange={(tab) => {
          onTabChange(tab);
          setIsSidebarOpen(false);
        }}
        user={user}
        onLogout={onLogout}
        isMobileOpen={isSidebarOpen}
        onMobileToggle={setIsSidebarOpen}
        theme={theme}
        onToggleTheme={onToggleTheme}
        isCollapsed={isSidebarCollapsed}
        onToggleCollapse={handleToggleCollapse}
      />
      
      <main className="flex-1 flex flex-col min-w-0 min-h-0 h-full overflow-hidden relative z-0">
        <div className="flex-1 overflow-y-auto overflow-x-hidden w-full scrollbar-enterprise">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-8 max-w-7xl w-full content-container">
            {children}
          </div>
        </div>
        
        <footer className={`border-t py-4 flex-shrink-0 ${
          isDark ? 'border-[#3c4043] bg-[#202124]' : 'border-gray-200 bg-white'
        }`}>
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
            <p className={`text-xs text-center ${isDark ? 'text-[#bdc1c6]' : 'text-gray-500'}`}>
              Powered by Vinson | © Vinson 2026
            </p>
          </div>
        </footer>
      </main>
    </div>
  );
};

export default AppLayout;

